const mutationTypes = {
  SET_IS_COLLAPSED: 'setIsCollapsed',
};

const state = {
  isCollapsed: false,
};

const mutations = {
  [mutationTypes.SET_IS_COLLAPSED]: (state, isCollapsed) => (state.isCollapsed = isCollapsed),
};

const actions = {
  setIsCollapsed: ({ commit }, isCollapsed) => {
    commit(mutationTypes.SET_IS_COLLAPSED, isCollapsed);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
